import { SanityArticleData } from 'lib/sanity/types';

/**
 * None and Control means the same from a data perspective, but we want to differentiate between the two
 * in the sense that Control means that the user is a part of a live AB test for the article, whereas None means that
 * the user is not a part of any live AB testing for that article. But the content is the same in both cases.
 * Treatment means that the user is a part of a live AB test for that article AND the content of the article is altered.
 */
export enum TreatmentState {
  None = 'none',
  Control = 'control',
  Treatment = 'treatment',
}

export type TreatedArticleData = SanityArticleData & {
  treatmentState: TreatmentState;
  treatmentKey?: string;
};
